import pulse from '@finn-no/pulse-sdk';
import { SearchVerticalConfig, type Vertical } from './config';

type Target = 'Listing' | 'Form';

// TR_ev01 - TR_ev09 (see tracking section in README.md)
export const trackSearchClick = (
    name: string,
    url: string,
    vertical: string,
    position: string,
    // biome-ignore lint/suspicious/noExplicitAny: Required for Pulse SDK compatibility
    item: any,
    targetType: Target = 'Listing',
): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Search',
        name: name,
        object: {
            // @ts-ignore id can only be string
            id: undefined, // set by Pulse SDK
            type: 'UIElement',
            elementType: 'Button',
            position,
            items: [item],
        },
        target: {
            id: url,
            type: targetType,
        },
        vertical: {
            name: 'travel',
            subVertical: vertical,
        },
    });
};

export const trackFhhBannerClick = (url: string): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Create',
        name: 'Click FHH frontpage banner',
        object: {
            id: 'fhh_banner_cta',
            type: 'UIElement',
            elementType: 'Button',
            name: 'Become a host',
        },
        target: {
            id: url,
            type: 'LandingPage',
        },
        vertical: {
            name: 'travel',
            subVertical: 'holiday_rental',
        },
    });
};

export const trackFhhItemCarouselClick = (itemId: string, itemTitle: string): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Click',
        name: 'Click FHH frontpage carousel card',
        object: {
            id: 'fhh_carousel_link',
            type: 'UIElement',
            elementType: 'Link',
        },
        target: {
            id: itemId,
            type: 'ClassifiedAd',
            name: itemTitle,
            category: 'travel > holiday rental',
        },
        vertical: {
            name: 'travel',
            subVertical: 'holiday_rental',
        },
    });
};

// Pulse tracker id: TR_pv01 - TR_pv05 (see tracking section in README.md)
export const trackBasicPageView = (vertical: Vertical): void => {
    let pulseVertical = '';
    let _url = '';

    switch (vertical) {
        case SearchVerticalConfig.flight.vertical:
            pulseVertical = 'flight';
            _url = SearchVerticalConfig.flight.fullPath;
            break;
        case SearchVerticalConfig.hotel.vertical:
            pulseVertical = 'hotel';
            _url = SearchVerticalConfig.hotel.fullPath;
            break;
        case SearchVerticalConfig.carrental.vertical:
            pulseVertical = 'car_rental';
            _url = SearchVerticalConfig.carrental.fullPath;
            break;
        case SearchVerticalConfig.prepackage.vertical:
            pulseVertical = 'prepackage';
            _url = SearchVerticalConfig.prepackage.fullPath;
            break;
        case SearchVerticalConfig.fhh.vertical:
            pulseVertical = 'holiday_rental';
            _url = SearchVerticalConfig.fhh.fullPath;
            break;
    }

    pulse.trackPageView({
        object: {
            type: 'MarketFrontpage',
            name: pulseVertical,
        },
        vertical: {
            name: 'travel',
            subVertical: pulseVertical,
        },
    });
};
